import React, { useMemo } from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { Flex } from '@atlassian/eoc-flex';

import { type SectionProps } from '../../common/types';
import { getNextId } from '../../common/utils';

import { Header } from './Header';

const hiddenContentStyles = cssMap({
	root: {
		display: 'none',
	},
});

export const Section = ({ children, className, ...props }: SectionProps) => {
	const id = useMemo(getNextId, []);

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		<Flex flexDirection="column" className={className}>
			<Header {...props} sectionId={id} />
			<Box
				id={`${id}-content`}
				xcss={props.isOpen === false && hiddenContentStyles.root}
				role="region"
				aria-labelledby={`${id}-header`}
			>
				{children}
			</Box>
		</Flex>
	);
};
